<!-- One router-outlet for every layout mode: crossing the mobile breakpoint (or logging in) only swaps the
	surrounding chrome, the page itself is not destroyed and recreated -->
@let mode = layoutMode;
<div [ngClass]="layoutClasses(mode)">
	@switch (mode) {
		@case ('client') {
			<app-client-navbar></app-client-navbar>
		}
		@case ('client-mobile') {
			<app-profile-icon-bar
				[hideProfileButton]="true"
				[showHamburger]="false"
				[hideTitle]="true">
			</app-profile-icon-bar>
		}
		@case ('backoffice') {
			<aside class="sidebar" [ngClass]="{
				'sidebar-desktop': !isMobileView(),
				'sidebar-responsive': isMobileView(),
				'collapsed': !isSidebarOpen,
				'expanded': isSidebarOpen
			}">
				<app-sidebar (sidebarToggle)="onSidebarToggle($event)"></app-sidebar>
			</aside>
		}
		@case ('backoffice-mobile') {
			<div class="profile-icon-bar expanded">
				<app-profile-icon-bar
					[hideProfileButton]="false"
					[showHamburger]="true"
					[isDetailPage]="isDetailPage"
					(hamburgerClick)="toggleSidebar()"
					(backClick)="goBack()">
				</app-profile-icon-bar>
			</div>
		}
	}

	<main class="main-content" [ngClass]="mainClasses(mode)">
		@if (mode === 'client-mobile' || mode === 'backoffice-mobile') {
			<app-install-banner></app-install-banner>
		}
		<router-outlet></router-outlet>
	</main>

	@switch (mode) {
		@case ('client-mobile') {
			<app-bottom-nav></app-bottom-nav>
		}
		@case ('backoffice') {
			<div class="profile-icon-bar" [ngClass]="{ 'expanded': !isSidebarOpen, 'collapsed': isSidebarOpen, 'detail-mode': isDetailPage }">
				<app-profile-icon-bar
					[hideProfileButton]="false"
					[showHamburger]="!isSidebarOpen"
					[showOnlyTitle]="isBoostPage"
					[avatarOnly]="isBoostPage"
					[isDetailPage]="isDetailPage"
					(hamburgerClick)="toggleSidebar()"
					(backClick)="goBack()">
				</app-profile-icon-bar>
			</div>

			@if (isSidebarOpen) {
				<button type="button" class="cancelled-menu" [attr.aria-label]="'common.a11y.closeMenu' | transloco" (click)="toggleSidebar()">
					<lucide-icon name="X" aria-hidden="true"></lucide-icon>
				</button>
			}
		}
		@case ('backoffice-mobile') {
			<app-sidebar (sidebarToggle)="onSidebarToggle($event)"></app-sidebar>
		}
	}
</div>

@if (isAuthenticated) {
	<app-profile
		[visible]="profileVisible"
		(visibleChange)="onProfileVisibleChange($event)">
	</app-profile>
}
